import styled, { css } from 'react-emotion';

export const PopupContentContainer = styled.div`
  display: flex;
`;
export const PopupHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const PopupBodyContainer = styled.div`
  margin-top: 40px;
  @media (max-width: 767px) {
    display: flex;
    margin-top: 20px;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

export const PopupHeader = styled.p`
  font-family: PlayfairDisplay;
  font-size: 32px;
  color: #e3e3e3;
  @media (max-width: 767px) {
    font-size: 24px;
  }
`;

export const FormContainer = styled.form`
  width: 100%;
`;

export const PopupContainer = css`
  padding: 30px 70px 54px 34px;
  max-width: 547px;
  position: relative;
  @media (max-width: 767px) {
    padding: 56px 16px 81px 16px;
    width: 100%;
  }
`;
export const CloseIconWrapper = styled.div`
  cursor: pointer;
  position: absolute;
  top: 29px;
  right: 20px;
  @media (max-width: 767px) {
    top: 18px;
    right: 18px;
  }
`;
export const ErrorContainer = styled.div`
  margin-top: 10px;
`;

export const ErrorMessage = styled.span`
  font-size: 14px;
  color: #ff4646;
`;
export const ErrorFooter = styled.div`
  margin-top: 6px;
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.43;
  color: #d0d0d0;
  & > a {
    color: #1c62fd;
  }
`;

export const submitButton = props => css`
  margin-top: 24px;
  padding: 11px 18px !important;
  display: flex;
  font-size: 12px !important;
  text-transform: uppercase;
  font-weight: 500 !important;
  align-items: center;
  @media (max-width: 767px) {
    width: 100%;
    margin-top: ${props.error ? '38px' : '66px'};
  }
  svg {
    margin-left: 6px;
    width: 11px;
    height: 11px;
  }
`;
export const LoaderIcon = css`
  margin-left: 6px;
  width: 11px;
  height: 11px;
`;
export const PopupBody = css`
  padding: 0px !important;
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
export const CloseIcon = css`
  width: 16px;
  height: 16px;
  fill: #999ca1;
`;
